// LiveChat.js
import React, { useState, useEffect, useRef } from 'react';
import '../../../../assests/css/admin/Help&Support/LiveChat/LiveChat.css';

const LiveChat = ({ onBack }) => {
  const [messages, setMessages] = useState([
    {
      id: 1,
      sender: 'user',
      text: "Hi there! I ordered a jacket three days ago (Order #5521) and the status still says 'Processing'. Is everything okay?",
      time: '10:42 AM'
    },
    {
      id: 2,
      sender: 'agent',
      text: "Hello Sarah! I'm happy to look into this for you. Just a moment while I check the warehouse logs for order #5521.",
      time: '10:44 AM'
    },
    {
      id: 3,
      sender: 'user',
      text: "Wait, is my order #5521 still on its way? I need it by Friday for a trip.",
      time: '10:45 AM'
    }
  ]);
  
  const [inputMessage, setInputMessage] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [selectedChat, setSelectedChat] = useState(0);
  const messagesEndRef = useRef(null);

  const chatList = [
    { 
      id: 0, 
      name: 'Sarah Johnson', 
      avatar: 'https://i.pravatar.cc/150?img=5', 
      lastMessage: "Wait, is my order #5521 still on its way?", 
      time: '2m ago', 
      status: 'online', 
      badge: 'VIP' 
    },
    { 
      id: 1, 
      name: 'Marcus Lee', 
      avatar: 'https://i.pravatar.cc/150?img=8', 
      lastMessage: 'Thank you for the refund help.', 
      time: '15m ago', 
      status: 'online' 
    },
    { 
      id: 2, 
      name: 'Elena Rodriguez', 
      avatar: 'https://i.pravatar.cc/150?img=9', 
      lastMessage: "I can't see the checkout button.", 
      time: '1h ago', 
      status: 'away' 
    }
  ];

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = () => {
    if (inputMessage.trim()) {
      const newMessage = {
        id: messages.length + 1,
        sender: 'user',
        text: inputMessage,
        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      };
      
      setMessages([...messages, newMessage]);
      setInputMessage('');
      setIsTyping(true);
      
      setTimeout(() => {
        setIsTyping(false);
        const agentResponse = {
          id: messages.length + 2,
          sender: 'agent',
          text: "Thank you for your patience. I'm checking on that for you right now.",
          time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        };
        setMessages(prev => [...prev, agentResponse]);
      }, 2000);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleEmojiClick = () => {
    setInputMessage(inputMessage + '😊');
  };

  return (
    <div className="AdminLiveChat-container">
      <div className="AdminLiveChat-sidebar">
        <div className="AdminLiveChat-sidebar-header">
          <span onClick={onBack} style={{cursor: 'pointer', color: '#3182ce'}}>Support</span>
          <span> › </span>
          <span>Live Chats</span>
        </div>
        
        <div className="AdminLiveChat-search">
          <input type="text" placeholder="Search chats..." />
        </div>

        <div className="AdminLiveChat-tabs">
          <button className="AdminLiveChat-tab AdminLiveChat-tab-active">Active ({chatList.length})</button>
          <button className="AdminLiveChat-tab">Past</button>
        </div>

        <div className="AdminLiveChat-list">
          {chatList.map((chat) => (
            <div 
              key={chat.id}
              className={`AdminLiveChat-list-item ${selectedChat === chat.id ? 'AdminLiveChat-list-item-active' : ''}`}
              onClick={() => setSelectedChat(chat.id)}
            >
              <div className="AdminLiveChat-list-avatar">
                <img src={chat.avatar} alt={chat.name} />
                <span className={`AdminLiveChat-status-${chat.status}`}></span>
              </div>
              <div className="AdminLiveChat-list-info">
                <div className="AdminLiveChat-list-name">{chat.name}</div>
                <div className="AdminLiveChat-list-message">{chat.lastMessage}</div>
              </div>
              <div className="AdminLiveChat-list-meta">
                <span className="AdminLiveChat-list-time">{chat.time}</span>
                {chat.badge && <span className="AdminLiveChat-list-badge">{chat.badge}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="AdminLiveChat-main">
        <div className="AdminLiveChat-header">
          <div className="AdminLiveChat-header-user">
            <img src={chatList[selectedChat].avatar} alt={chatList[selectedChat].name} />
            <div>
              <div className="AdminLiveChat-header-name">
                {chatList[selectedChat].name}
                <span className="AdminLiveChat-header-verified">✓</span>
              </div>
              <div className="AdminLiveChat-header-info">Order #5521 • Connected to Agent #402</div>
            </div>
          </div>
          <div className="AdminLiveChat-header-actions">
            <button className="AdminLiveChat-minimize">− Minimize</button>
            <button className="AdminLiveChat-end" onClick={onBack}>× End Chat</button>
          </div>
        </div>

        <div className="AdminLiveChat-messages">
          <div className="AdminLiveChat-date">TODAY, OCT 24</div>
          
          {messages.map((msg) => (
            <div key={msg.id} className={`AdminLiveChat-message AdminLiveChat-message-${msg.sender}`}>
              {msg.sender === 'user' && <img src={chatList[selectedChat].avatar} alt="User" />}
              {msg.sender === 'agent' && (
                <div className="AdminLiveChat-agent-avatar">A</div>
              )}
              <div className="AdminLiveChat-message-bubble">
                {msg.text}
                <div className="AdminLiveChat-message-time">{msg.time}</div>
              </div>
            </div>
          ))}

          {isTyping && (
            <div className="AdminLiveChat-typing">
              <span>Agent is typing...</span>
            </div>
          )}
          
          <div ref={messagesEndRef} />
        </div>

        <div className="AdminLiveChat-input">
          <button className="AdminLiveChat-input-icon" onClick={handleEmojiClick} title="Add emoji">
            😊
          </button>
          <button className="AdminLiveChat-input-icon" title="Attach file">
            📎
          </button>
          <button className="AdminLiveChat-input-icon" title="Add image">
            🖼️
          </button>
          <input
            type="text"
            placeholder="Type your message here..."
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button className="AdminLiveChat-send" onClick={handleSendMessage}>
            Send ➤
          </button>
        </div>
      </div>
    </div>
  );
};

export default LiveChat;